import React from "react";
import { motion } from "framer-motion";
import { ClipboardEdit, Eye, Trash2, X } from "lucide-react";
import AppointmentTooltip from "./AppointmentTooltip";

const FormModal = ({ title, onClose, onView, onEdit, onDelete, value, setValue }) => {
  return (
    <motion.div
      className="fixed inset-0 z-[1000] bg-black bg-opacity-40 flex items-center justify-center px-fluid-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-xl w-full max-w-md p-fluid-4 space-y-fluid-4"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        {/* Header */}
        <div className="flex justify-between items-center">
          <h2 className="text-fluid-lg font-semibold text-gray-900">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>

        {/* Read-only content */}
        <div className="space-y-fluid-2">
          <label className="block text-fluid-sm font-medium text-gray-700">
            Details
          </label>
          <div
            className="w-full border border-gray-200 rounded-md px-fluid-2 py-fluid-2 text-fluid-base bg-gray-50 text-gray-900 whitespace-pre-wrap break-words max-h-64 overflow-auto cursor-default"
            aria-readonly="true"
          >
            {value || "No details available"}
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200">
          {onDelete && (
            <AppointmentTooltip content={value}>
              <button
                onClick={onDelete}
                className="inline-flex items-center gap-1 bg-Delete-red text-white px-fluid-button-x py-fluid-button-y rounded text-fluid-sm hover:bg-red-700 transition"
              >
                <Trash2 size={16} />
                Delete
              </button>
            </AppointmentTooltip>
          )}
          <AppointmentTooltip content={value}>
            <button
              onClick={onClose}
              className="px-fluid-button-x py-fluid-button-y border border-gray-300 text-gray-700 rounded text-fluid-sm hover:bg-gray-100"
            >
              Cancel
            </button>
          </AppointmentTooltip>
          <AppointmentTooltip content={value}>
            <button
              onClick={onView}
              className="inline-flex items-center gap-1 px-fluid-button-x py-fluid-button-y text-white bg-blue-500 rounded hover:bg-blue-600 transition text-fluid-sm"
            >
              <Eye size={16} />
              View
            </button>
          </AppointmentTooltip>
          {/* <button
            onClick={onEdit}
            className="inline-flex items-center gap-1 px-fluid-button-x py-fluid-button-y text-white bg-[#1e2a74] rounded hover:bg-[#18225c] transition text-fluid-sm"
          >
            <ClipboardEdit size={16} />
            Edit
          </button> */}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default FormModal;
